import { render, staticRenderFns } from "./ConfiguracionListado.vue?vue&type=template&id=ff719df2"
import script from "./ConfiguracionListado.vue?vue&type=script&lang=js"
export * from "./ConfiguracionListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports